export { LandiingPage } from "./LandiingPage";
